import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { useStyles } from "./styles";

export default function SemDados({ text }) {
  const classes = useStyles();

  return (
    <div className={classes.emptyData}>
      <div>
        <CloseIcon /> {text}
      </div>
    </div>
  );
}
